export default __webpack_public_path__ + "locales/sr-Latn-RS/PortalUnavailable.json?hash=aa418cbaa93787bbe9eef8417949af26";